import { Link } from "react-router-dom";
import { articles, type Article } from "@/mocks/articles";

export default function LatestArticles() {
  const latest = [...articles].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <section className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
          最新内容
        </h2>
        <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
          每日更新，不错过任何精彩内容
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {latest.map((article: Article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group flex flex-col bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-amber-200 transition-all duration-300 cursor-pointer hover:-translate-y-1"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                title={article.title}
                loading="lazy"
              />
            </div>
            <div className="flex-1 flex flex-col p-5">
              <h3 className="text-base font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-amber-600 transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-gray-500 line-clamp-2 mb-3 leading-relaxed flex-1">
                {article.description}
              </p>
              <div className="flex items-center justify-between text-xs text-gray-400 pt-3 border-t border-gray-50">
                <div className="flex items-center gap-3">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                </div>
                <span className="text-amber-500 font-medium">
                  阅读更多
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}